import PureRenderMixin from 'react-addons-pure-render-mixin';
import React from 'react';

import CircleIcon from './icons/circle_icon';
import styled from 'styled-components';
import DialPadFillIcon from 'components/common/icons/fill/dial-pad-fill';

export default class KeypadButton extends React.Component {
  constructor(props) {
    super(props);
    this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
  }
  render() {
    return (
      <CircleIcon viewBox="0 0 25 25" {...this.props}>
        <StyledDialPadFillIcon />
      </CircleIcon>
    );
  }
}

const StyledDialPadFillIcon = styled(DialPadFillIcon)`
  rect {
    transform: scale(0.6);
    transform-origin: center;
  }
`;
